import {OperationErrorType, StoreAction} from "orpyx-web-common";
import {IOrganizationChannelDto} from "admins-dashboard/http-clients/index";

export enum ChannelsActions {
    INITIALIZE = 'CHANNELS: INITIALIZE',
    INITIALIZE_SUCCESSFULLY = 'CHANNELS: INITIALIZE_SUCCESSFULLY',
    INITIALIZE_FAILED = 'CHANNELS: INITIALIZE_FAILED',
}

export const CHANNELS_INITIALIZE = (): StoreAction<ChannelsActions> => ({
    type: ChannelsActions.INITIALIZE
});

export const CHANNELS_INITIALIZE_SUCCESSFULLY = (channels: IOrganizationChannelDto[]): StoreAction<ChannelsActions> => ({
    type: ChannelsActions.INITIALIZE_SUCCESSFULLY, payload: channels
});

export const CHANNELS_INITIALIZE_FAILED = (error: OperationErrorType): StoreAction<ChannelsActions> => ({
    type: ChannelsActions.INITIALIZE_FAILED, payload: error
});
